import { useEffect, useState } from "react";
import Header from "./common/components/header/header";
import Section1 from "./common/modules/app/components/section1";
import MobileMenu from "./common/components/header/mobile";
import Section2 from "./common/modules/app/components/section2";
import Section8 from "./common/modules/app/components/section8";
import Section9 from "./common/modules/app/components/section9";
import Section7 from "./common/modules/app/components/section7";
import Section6 from "./common/modules/app/components/section6";
import Section5 from "./common/modules/app/components/section5";
import Section4 from "./common/modules/app/components/section4";
import Section3 from "./common/modules/app/components/section3";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  

  
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isOpen]);
  return (
    <div className={`flex flex-col overflow-hidden`}>
      <Header
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
       />
      <Section1 isOpen={isOpen} toggleSidebar={toggleSidebar} />
      <Section2 />
      <MobileMenu
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
      />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9 />
    </div>
  );
}
  
export default App;
